import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfiguracionEmpresaComponent } from './configuracion-empresa.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../material/material.module';
import { BotonToggleModule } from '../boton/boton-toggle.module';
import { ConfiguracionEmpresaRoutingModule } from './configuracion-empresa-routing.module';
import { DetalleConfiguracionEmpresaComponent } from './detalle-configuracion-empresa/detalle-configuracion-empresa.component';
import { ImageUploadModule } from '../archivos/image-upload.module';
import { ConfiguracionEmpresaService } from '../../providers/configuracion-empresa.service';
import { NgxMaskModule, IConfig } from 'ngx-mask';
@NgModule({
  declarations: [ConfiguracionEmpresaComponent, DetalleConfiguracionEmpresaComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    BotonToggleModule,
    ReactiveFormsModule,
    ConfiguracionEmpresaRoutingModule,
    ImageUploadModule.forRoot(),
    NgxMaskModule.forRoot(),
  ],
})
export class ConfiguracionEmpresaModule { }
